import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperEl = element.querySelector(".instructions-slider");

    const swiper = new Swiper(swiperEl, {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 10,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        breakpoints: {
            1500: {
                slidesOffsetAfter: 125,
                slidesOffsetBefore: 125,
                spaceBetween: 30,
            }
        },
        on: {
            init(swiper) {
                centerIfFewSlides(swiper);
            },
            resize(swiper) {
                centerIfFewSlides(swiper);
            }
        }
    });

    function centerIfFewSlides(swiper) {
        const wrapper = swiper.wrapperEl;
        const slides = swiper.slides;

        let totalWidth = 0;

        slides.forEach(slide => {
            totalWidth += slide.offsetWidth;
        });

        totalWidth += swiper.params.spaceBetween * (slides.length - 1);

        if (totalWidth < swiper.width) {
            wrapper.classList.add('is-centered');
        } else {
            wrapper.classList.remove('is-centered');
        }
    }

    element.swiper = swiper;

    // фильтрация
    const categoryFilterBtns = element.querySelectorAll('.category__filter_item');
    const slides = element.querySelectorAll('.slide__item');

    let activeCategory = null;

    categoryFilterBtns.forEach(catBtn => {
        catBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const catId = catBtn.dataset.category_id;

            // сброс фильтра
            if (activeCategory === catId) {
                activeCategory = null;

                categoryFilterBtns.forEach(btn => btn.classList.remove('active'));
                slides.forEach(slide => slide.classList.remove('hidden'));

                swiper.update();
                centerIfFewSlides(swiper);
                return;
            }

            activeCategory = catId;

            categoryFilterBtns.forEach(btn => btn.classList.remove('active'));
            catBtn.classList.add('active');

            slides.forEach(slide => {
                slide.classList.toggle(
                    'hidden',
                    slide.dataset.category_id !== catId
                );
            });

            swiper.update();
            centerIfFewSlides(swiper);
        });
    });
}